module.exports = __webpack_public_path__ + "img/banner-m.8fa0d20b.png";